<div class="custom-container">
  <div class="copyRight">2024 ©</div>
  <div class="version">
    <div *ngIf="false" [ngStyle]="{ backgroundColor: isProd ? 'red' : '', color: isProd ? 'white' : '' }" (click)="openModal()">{{ environMent }}</div>
    <div *ngIf="false" (click)="counterChange()">{{ version }}</div>
  </div>
</div>
